<template>
    <section class="leading-[1.4] py-14 xl:py-24 px-10 will-change" :data-scroll-section="inner == 'false'">
        <div class="will-change flex flex-col items-center justify-center" data-scroll data-scroll-class="xyz-in" xyz="fade down duration-15">
            <h2 class="text-4xl xl:text-heading mb-8 text-center" v-show="blockData.title">{{ blockData.title }}</h2>
            <div class="text-lg md:text-xl text-center font-canela font-light xl:w-[55vw]" v-show="blockData.text" v-html="blockData.text"></div>
            <img class="mb-8 xl:mb-14" v-if="blockData.image" :src="blockData.image.url" :alt="blockData.image.alt">
        </div>
    </section>
</template>


<script>
    export default {
        name: 'SimpleImageBlock',
        data() {
            return {}
        },
        mounted() {

        },
        computed: {
            /* computedClass() {
                let className = '';
                if ( this.blockData.background_color === 'White' ) {
                    className = [
                        'bg-transparent',
                        'text-navy-blue-02'
                    ]
                }
                if ( this.blockData.background_color === 'Light Blue' ) {
                    className = [
                        'bg-light-blue-03',
                        'text-navy-blue-02'
                    ]
                }
                if ( this.blockData.background_color === 'Dark Blue' ) {
                    className = [
                        'bg-navy-blue-01',
                        'text-white'
                    ]
                }
                return className;
            } */
        },
        methods: {
            openBlank: function (link) {
                window.open(link, "_blank");
            }
        },
    }
</script>
